<template>
  <footer class="f">
    <div class="wrap footer-inner">
      <div>{{ t('footer.copyright') }}</div>
      <div>
        <router-link :to="localePath('/contact')">{{ t('footer.contact') }}</router-link>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useLocale } from '@/composables/useLocale'
const { t, localePath } = useLocale()
</script>

<style>
footer.f {
  position: relative;
  z-index: 1;
  padding: 56px 0 40px;
  border-top: 1px solid var(--line-on-blue);
  background: var(--bg);
  color: var(--ink-on-blue-soft);
}
.footer-inner {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 16px;
  font-size: 13px;
}
.footer-inner a { color: var(--ink-on-blue); }
.footer-inner a:hover { color: var(--cream); }
</style>
